<div class="row middle-xs footer">
  <div class="padding-left">
    <b>¿Necesitas ayuda?</b> Llámanos al 01 800 426 4663
  </div>
  <div class="padding-right align-items">
    <a href="{{ anexoFiscalUrl }}" target="_blank" rel="noopener noreferrer"
      >Aviso fiscal</a
    >
    <a href="{{ privacyAdvice }}" target="_blank" rel="noopener noreferrer"
      >Aviso de privacidad</a
    >
    <a
      href="https://www.gbmhomebroker.com/pdf/GBMhomebrokerTerminosCondiciones.pdf"
      target="_blank"
      rel="noopener noreferrer"
      >Términos y condiciones</a
    >
  </div>
</div>
